<div class="container-main">
  <div class="container">
    <div class="row">
      <div class="col-12 form-group">
        <img class="image-close" src="../../../assets/close.png" (click)="goToReturn()">
      </div>
      <div class="col-12 form-group">
        <img class="image-detail" [src]="course.photoUrl">
      </div>
      <div class="col-12 form group">
        <p class="title-detail">{{ course.title }}</p>
      </div>
      <div class="col-12 col-sm-8 offset-sm-2 form group">
        <p class="subtitle-detail">{{ course.subtitle }}</p>
      </div>
      <div class="col-12">
        <div class="container-video">
          <youtube-player 
            videoId="{{course.videoUrl}}" 
            suggestedQuality="highres" 
            [height]="250" 
            [width]="500" 
            [startSeconds]="0"
            >
          </youtube-player>
        </div>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 col-sm-6 form-group">
        <p class="title2">Calificación</p>
        <div class="row">
          <div class="col-12 col-sm-6 form-group">
            <span class="grade">{{ course.score }}</span>
          </div>
          <div class="col-12 col-sm-6 form-group">
            <span class="stars">
              <span [ngStyle]="{ 'width': getStars(course.score) }"></span>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 form-group">
        <p class="title2">Estudiantes</p>
        <p class="text-student">{{ course.students }}</p>
      </div>
      <div class="col-12 form-group">
        <button class="button-get" (click)="goToCourse(course)">Obtener Curso</button>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <p class="title2">Habilidades</p>
        <ul>
          <li *ngFor="let item of course.skills">
            <p>{{ item }}</p>
          </li>
        </ul>
      </div>
      <div class="col-12 form-group">
        <p class="title2">Descripción</p>
        <div *ngFor="let item of course.description">
          <p class="text" *ngIf="item == '\n'">&nbsp;</p>
          <p class="text" *ngIf="item != '\n' || item != '\\n'">{{ item }}</p>
        </div>
      </div>
      <div class="col-12 form-group">
        <p class="title2">Crea apps increíbles con este curso</p>
      </div>
      <div class="col-12 form-group container-flex">
        <div class="container-screen" *ngFor="let screen of course.screenshots">
          <img class="image-screen" [src]="screen">
        </div>
      </div>
      <div class="col-12 form-group">
        <button class="button-get" (click)="goToCourse(course)">Obtener Curso</button>
      </div>
    </div>
  </div>
</div>